export enum SubscriptionPeriod {
    Monthly = "month",
    Annual = "year",
}
